import React, { FC } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { BaseProps } from 'shared/types/base';
import { DialogTitleWithClose } from 'ui';

type ESGEntityRemovalConfirmationModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm?: () => void;
} & BaseProps;

const ESGEntityRemovalConfirmationModal: FC<ESGEntityRemovalConfirmationModalProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
        <DialogTitleWithClose onClose={onClose}>
          {t('ESG.ENTITY_REMOVAL_CONFIRMATION')}
        </DialogTitleWithClose>
        <DialogContent>
          <Typography variant="body2">{t('ESG.ENTITY_REMOVAL_CONFIRMATION_DESC')}</Typography>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={onClose}>
            {t('CANCEL')}
          </Button>
          <Button variant="contained" color="primary" onClick={onConfirm}>
            {t('CONTINUE')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ESGEntityRemovalConfirmationModal;
